class Header {

  constructor() {
    this.searchOpen = false;
    this.menuOpen = false;
    this.burgerOpen = false;
    this.sharingOpen = false;
    this.closeButton = false;

    this.htmlTag = document.getElementsByTagName( 'html' )[0];
    this.header = document.querySelector('.header');
    this.headerContainer = document.querySelector('.header__container');
    this.searchToggle = document.querySelector('.js-search-toggle');
    this.burgerToggle = document.querySelector('.js-burger-toggle');
    this.burger = document.querySelector('.burger');
    this.searchFormDesktop = document.querySelector(".search-container--desktop");
    this.menuContainer = document.querySelector(".menu-container");
    this.searchFormInput = document.querySelector('.form__input--search');
    this.sharingButton = document.querySelector(".js-sharing-toggle");
    this.sharingList = document.querySelector(".sharing__list--level-1");
    this.closeSharingButton = document.querySelector(".sharing__icon--close");
    this.sharingIcon = document.querySelector(".svg-share");
    this.menuItemHasChildren = document.querySelectorAll(".menu__item--has-children");
    this.menuItemHasChildrenLinks = document.querySelectorAll(".menu__item--has-children > .menu__link");
    this.menuItemHasNoChildrenLinks = document.querySelectorAll(".menu__item--has-no-children > .menu__link");
    this.menuItemBack = document.querySelectorAll(".menu__item--back > .menu__link");
    this.mainMenu = document.getElementById("main-menu");
    this.lottie = document.getElementsByTagName('lottie-player');

    this.resizeTimer;
    this.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    this.vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    this.bindEvents();
  }

  bindEvents() {
      for (var i = 0; i < this.lottie.length; i++) {
        this.lottie[i].addEventListener('play', (event) => {
          // console.log(event.target.shadowRoot.querySelector('svg').style.transform);
          event.target.shadowRoot.querySelector('svg').style.transform = '';
        });
        this.lottie[i].play(); // trigger (again)
      }


    this.burgerToggle?.addEventListener("click", (e) => {
      this.closeSearch();
      this.toggleBurger();
      this.toggleMenu();
    });

    this.sharingButton?.addEventListener("click", (e) => {
      this.toggleMeta();
    });

    this.searchToggle?.addEventListener("click", (e) => {
      const mediaQuery = window.matchMedia('(min-width: 992px)');
      if(mediaQuery.matches){
        this.closeMenu();
        this.closeBurger();
      }
      this.toggleSearch(e);
    });

    this.menuItemHasNoChildrenLinks.forEach(item => {
      item.addEventListener('click', event => {
        if(item.href.includes('#')){
          this.toggleBurger();
          this.closeMenu();
        }
      });
    });

    this.menuItemHasChildrenLinks.forEach(item => {
      item.addEventListener('click', event => {
        this.openSubMenu(event);
      })
    });

    this.menuItemBack.forEach(item => {
      item.addEventListener('click', event => {
        this.closeSubMenu(event);
      })
    });

    window.addEventListener('scroll', this.handleScroll.bind(this));


    // window.addEventListener('load', () => {
    //   this.setMenuContainerHeight();
    // });

    // window.addEventListener('resize', () => {
    //   clearTimeout(this.resizeTimer);
    //   this.resizeTimer = setTimeout(function(that) {
    //     that.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    //     that.vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    //     that.setMenuContainerHeight();
    //   }(this), 250);
    // });
  }

  handleScroll() {
    if (window.scrollY > 100) {
      this.header.classList.add('scrolled');
    } else {
      this.header.classList.remove('scrolled');
    }
  }

  toggleMeta() {

    if (this.sharingOpen) {
      this.sharingList.classList.remove('sharing-open');
      this.sharingIcon.classList.remove('active')
      this.closeSharingButton.classList.remove('active')

      this.sharingOpen = false;
    } else {
      this.sharingList.classList.add('sharing-open');
      this.sharingIcon.classList.add('active')
      this.closeSharingButton.classList.add('active')

      this.sharingOpen = true;
    }
  }

  toggleBurger() {
    if (this.burgerOpen) {
      this.burger.classList.remove('burger-open');
      this.burgerOpen = false;
    } else {
      this.burger.classList.add('burger-open');
      this.burgerOpen = true;
    }
  }

  closeBurger() {
    this.burger.classList.remove('burger-open');
    this.burgerOpen = false;
  }

  toggleMenu() {
    if (this.menuOpen) {
      this.menuContainer.classList.remove('menu-open');
      this.htmlTag.classList.remove('menu-open');
      this.menuOpen = false;
    } else {
      this.menuContainer.classList.add('menu-open');
      this.htmlTag.classList.add('menu-open');
      this.menuOpen = true;
    }

  }

  closeMenu() {
    this.menuContainer.classList.remove('menu-open');
    this.menuOpen = false;
  }

  toggleSearch(e) {
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    if(mediaQuery.matches){
      if (this.searchOpen) {
        this.searchFormDesktop.classList.remove('search-open');
        this.searchOpen = false;
      } else {
        this.searchFormDesktop.classList.add('search-open');
        this.searchFormDesktop.querySelector('input').focus();
        this.searchOpen = true;
      }
    } else{
      this.toggleMenu();
      this.searchFormInput.focus();
    }
  }

  closeSearch() {
    this.searchFormDesktop.classList.remove('search-open');
    this.searchOpen = false;
  }

  openSubMenu(e) {
    e.stopPropagation();
    let target = e.target.closest(".menu__item--has-children");

    if (this.vw >= 992) {
      this.menuItemHasChildren.forEach(item => {
        item.classList.remove('menu-open');
      })
    }

    target.classList.add('menu-open');
  }

  closeSubMenu(e) {
    e.stopPropagation();
    let target = e.target.closest(".menu-open");
    target.classList.remove('menu-open');
  }

  setMenuContainerHeight() {
    let height = (this.vh - this.headerContainer.offsetHeight + 1);

    if (this.vw >= 992) {
      let level1Height = document.querySelectorAll('.menu__item--level-0').length * document.querySelector('.menu__item--level-0').offsetHeight;
      level1Height = level1Height + 120; //padding-bottom

      if (height < this.mainMenu.offsetHeight) {
        height = level1Height;
      }
    }

    this.menuContainer.style.height = height + 'px';
  }

}

export default Header;
